import { Component, Input } from "@angular/core";
import { AccountService } from "@modules/account/services/account.service";
import { TradableActionButtonsComponent } from "../../tradable-action-buttons/tradable-action-buttons.component";
import { matchesMediaQuery } from "@helpers/utils";
import { TooltipService } from "@main-services/tooltip.service";
import { UserService } from "@main-services/user.service";
import { TradableWalletListService } from "@main-services/wallet/tradable_wallet_list.service";
import { FiatWalletService } from "@main-services/wallet/fiat_wallet.service";
import { StockTestService } from "@main-services/stock-test.service";
import { ModalService } from "@core-services/modal.service";
import { TranslationService } from "@core-services/translation.service";
import { StockTestHelperService } from "@main-services/stock-test-helper.service";
import { StakingFacade } from "@modules/staking/domain/+state/staking.facade";
import { SMALL_DEVICES_WIDTH_THRESHOLD } from "@helpers/constants";
import { SendEntryPointService } from "@modules/+new/payments/features/send/domain/send-entry-point.service";
import { EMPTY, Observable } from "rxjs";
import { WalletBalance } from "@modules/+new/core/wallets-balances/domain/entities/wallet-balance.model";
import { StakedAssetFacade } from "@modules/staking/domain/+state/staked-asset.facade";
import { UserFiatFundsService } from "@modules/shared/services/user-fiat-funds.service";
import { FiatDepositEntryService } from "@modules/+new/payments/features/fiat-deposit/infrastructure/fiat-deposit-entry.service";
import { LaunchDarklyService } from "@core-services/launch-darkly/launch-darkly.service";
import { CryptoDepositFacade } from "@modules/+new/payments/features/crypto-deposit/domain/+state/crypto-deposit.facade";
import { CryptoDepositStateService } from "@modules/+new/payments/features/crypto-deposit/domain/+state/crypto-deposit-state.service";
import { CheckoutEntryHelperService } from "@modules/checkout/services/checkout-entry-helper.service";
import { LimitOrdersTrackingFacade } from "@modules/limit-orders/services/orders-rudderstack.facade";
import { ActionButtonsFacade } from "@modules/discover/domain/+state/action-buttons.facade";

@Component({
	selector: "asset-mobile-action-button-wrapper",
	templateUrl: "./asset-mobile-action-button-wrapper.component.html",
	styleUrls: ["./asset-mobile-action-button-wrapper.component.scss"],
	providers: [CryptoDepositFacade, CryptoDepositStateService],
	standalone: false
})
export class AssetMobileActionButtonWrapperComponent extends TradableActionButtonsComponent {
	@Input()
	public balance$: Observable<WalletBalance> = EMPTY;

	public constructor(
		protected modalService: ModalService,
		protected accountService: AccountService,
		protected tradableWalletListService: TradableWalletListService,
		protected translationService: TranslationService,
		protected fiatWalletService: FiatWalletService,
		protected userService: UserService,
		protected tooltipService: TooltipService,
		protected stockTestService: StockTestService,
		protected stockTestHelperService: StockTestHelperService,
		protected stakingFacade: StakingFacade,
		protected sendEntryPoint: SendEntryPointService,
		protected stakedAssetFacade: StakedAssetFacade,
		protected userFiatFundsService: UserFiatFundsService,
		protected readonly fiatDepositEntryService: FiatDepositEntryService,
		protected readonly launchDarklyService: LaunchDarklyService,
		protected readonly checkoutEntryHelper: CheckoutEntryHelperService,
		protected readonly cryptoDepositFacade: CryptoDepositFacade,
		protected readonly limitOrdersTrackingFacade: LimitOrdersTrackingFacade,
		protected readonly actionButtonsFacade: ActionButtonsFacade
	) {
		super(
			modalService,
			accountService,
			tradableWalletListService,
			translationService,
			fiatWalletService,
			tooltipService,
			userService,
			stockTestService,
			stockTestHelperService,
			stakingFacade,
			userFiatFundsService,
			fiatDepositEntryService,
			stakedAssetFacade,
			sendEntryPoint,
			launchDarklyService,
			checkoutEntryHelper,
			cryptoDepositFacade,
			limitOrdersTrackingFacade,
			actionButtonsFacade
		);
		this.onResize();
	}

	public onResize(): void {
		this.mobileWindow = !matchesMediaQuery(SMALL_DEVICES_WIDTH_THRESHOLD);
	}
}
